// Generated by scripts/build-ui-icons.mjs.
export { Warning as default } from "../ui/glyphs-8";
